import { Platform, StyleSheet } from 'react-native';

import { C } from '../../../../common';
import { LAYOUT, THEME } from '../../../../reactor/common';

const { UNIT, OFFSET } = THEME;

export default StyleSheet.create({
  container: {
    height: '100%',
    justifyContent: 'flex-start',
  },

  content: {
    maxWidth: C.CONTENT_MAX_WIDTH,
  },

  bottom: StyleSheet.flatten([
    LAYOUT.STYLE.ROW,
    {
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      position: 'absolute',
      left: OFFSET,
      right: OFFSET,
      bottom: OFFSET,
    },
  ]),

  button: {
    alignSelf: 'flex-start',
    marginTop: UNIT,
  },

  subtitleFirst: {
    ...Platform.select({
      web: {
        order: -1,
      },
    }),
  },

  image: {
    height: 75,
  },

  safeArea: {
    width: 245,
  },

  linkContainer: {
    alignSelf: 'flex-end',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  linkImage: {
    height: UNIT * 4.8,
    width: UNIT * 4.8,
  },

  linkText: {
    marginTop: UNIT / 2,
    opacity: 0.75,
  },
});
